function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys1 = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys1 = ownKeys1.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys1.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import regeneratorRuntime from "regenerator-runtime";
import { defineComponent, ref, toRefs, watch, computed, reactive, onMounted, getCurrentInstance } from "vue";
import searchMixin from "@/mixin/search";
import TabsModular from "./modular/tabs-modular.vue";
import SearchModular from "@/components/SearchV3/index.vue";
import OperationModular from "./modular/operation-modular.vue";
import TableModular from "./modular/table-modular.vue";
import CardModular from "./modular/card-modular.vue";
import BatchModular from "./modular/batch-modular.vue";
import TreeModular from "./modular/tree-modular.vue";
import Pagination from "@/components/Pagination/index.vue";
import PublicDialog from "./dialog/index.vue";
import ViewDialog from "./dialog/view-dialog.vue";
import { formItemSearch, formItemQuery } from "./config/form";
import { editSearchQuery, getTreeHeight, getTemplateLabel } from "./config/methods";
import { getAssetList } from "@/api/public_resource";
import { getFragmentList, getFragmentTags } from "@/api/veditor/index";
import { TabsType } from "@/views/repository/resource/config/enums";
import EditDialog from "@/views/producer/video-template/components/edit-dialog.vue";
import { filterEmptyObjects } from "@ve-pro/ve/aside/modular/template-modular/components/index";
import store from "@/store";
import _ from "lodash";
export default defineComponent({
    name: "public-resource",
    mixins: [
        searchMixin
    ],
    components: {
        TabsModular: TabsModular,
        SearchModular: SearchModular,
        OperationModular: OperationModular,
        TableModular: TableModular,
        CardModular: CardModular,
        BatchModular: BatchModular,
        TreeModular: TreeModular,
        PublicDialog: PublicDialog,
        ViewDialog: ViewDialog,
        Pagination: Pagination,
        EditDialog: EditDialog
    },
    setup: function setup(props) {
        var handleClickRow = function handleClickRow(row) {
            rowItem.value = row;
            editVisible.value = true;
        };
        var instance = getCurrentInstance();
        var root = instance === null || instance === void 0 ? void 0 : instance.proxy;
        var treeHeight = ref(0);
        var radioValue = ref("list");
        var editVisible = ref(false);
        var rowItem = ref();
        var checkedRow = ref([]);
        var fragmentTags = ref([]);
        var treeRef = ref();
        var tableListRef = ref();
        var activeTab = computed(function() {
            return store.state.resource.activeTab;
        });
        var treeParams = reactive({
            group_type: 4,
            asset_type: 0
        });
        var formList = reactive(formItemSearch);
        var formQuery = reactive({
            query: formItemQuery
        });
        var resourceTable = reactive({
            tableColumnConfig: [],
            tableList: [],
            listLoading: false,
            tableListTotal: 0
        });
        var changeRadio = function(value) {
            radioValue.value = value;
        };
        var checkedTableColumns = function(value) {
            var // @ts-ignore
            _$ref;
            resourceTable.tableColumnConfig = value;
            (_$ref = tableListRef.value) === null || _$ref === void 0 ? void 0 : _$ref.tableListRef.doLayout();
        };
        var handleSelectionChange = function(val) {
            checkedRow.value = val;
        };
        var refreshAssetList = function() {
            editSearchQuery(formQuery.query);
            initResourceList(formQuery.query);
        };
        var handleSortChange = function(value) {
            formQuery.query.order = value.prop;
            if (value.order === "descending") {
                formQuery.query.order = "-" + value.prop;
            }
            refreshAssetList();
        };
        var handleNodeId = function(data) {
            if (typeof data === "boolean") {
                // formQuery.query.tag_ids = ''
                formQuery.query.no_tag = data;
            } else {
                formQuery.query.tag_ids = data;
            // formQuery.query.no_tag = false
            }
            formQuery.query.page = 1;
            root.$route.query.tag_ids = formQuery.query.tag_ids;
            root.$route.query.no_tag = String(formQuery.query.no_tag);
            root.$route.query.page = String(formQuery.query.page);
            checkedRow.value = [];
            refreshAssetList();
        };
        function initResourceList(param) {
            return _initResourceList.apply(this, arguments);
        }
        function _initResourceList() {
            _initResourceList = _asyncToGenerator(regeneratorRuntime.mark(function _callee(param) {
                var api, res;
                return regeneratorRuntime.wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            resourceTable.listLoading = true;
                            api = activeTab.value === TabsType.FRAGMENT ? getFragmentList({
                                searchName: param.searchName,
                                order: param.order,
                                keyword: String(param.keyWords),
                                audit_status: param.audit_status,
                                show_status: param.show_statuses,
                                is_public: 1,
                                only_inner: param.only_inner ? Number(param.only_inner) : "",
                                tag_ids: param.tag_ids,
                                page: param.page,
                                page_size: param.page_size
                            }) : getAssetList(param);
                            _ctx.prev = 2;
                            _ctx.next = 5;
                            return api;
                        case 5:
                            res = _ctx.sent;
                            resourceTable.tableList = (res.data.data.list || []).map(function(item) {
                                // 动作中，如果上传的是 glb, 需要拼接内容到 preview_urls 里面，方便子组件预览
                                if (item.type === TabsType.ACTION && item.preview_urls && !item.preview_urls.length) {
                                    return _objectSpreadProps(_objectSpread({}, item), {
                                        preview_urls: [
                                            item.file_url
                                        ]
                                    });
                                // 片段列表根据tagIds获取对应的tag_names，解析封面与预览数据
                                } else if (activeTab.value === TabsType.FRAGMENT) {
                                    var templateTagArray = getTemplateLabel(fragmentTags.value, item.tag_ids);
                                    return _objectSpreadProps(_objectSpread({}, item), {
                                        tag_names: _.map(templateTagArray, "name").join(",") || "-",
                                        cover_previews: item.cover_previews && filterEmptyObjects(JSON.parse(item.cover_previews)) || null,
                                        previews: item.previews && filterEmptyObjects(JSON.parse(item.previews)) || null
                                    });
                                }
                                return item;
                            });
                            // console.log(resourceTable.tableList, 'resourceTable.tableList')
                            resourceTable.tableListTotal = res.data.data.total;
                            checkedRow.value = [];
                            resourceTable.listLoading = false;
                            _ctx.next = 15;
                            break;
                        case 12:
                            _ctx.prev = 12;
                            _ctx.t0 = _ctx["catch"](2);
                            resourceTable.listLoading = false;
                        case 15:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        2,
                        12
                    ]
                ]);
            }));
            return _initResourceList.apply(this, arguments);
        }
        // 处理tree loading
        var tabsLoading = computed(function() {
            var _$ref;
            return (_$ref = treeRef.value) === null || _$ref === void 0 ? void 0 : _$ref.treeLoading;
        });
        function fragmentTagsList() {
            return _fragmentTagsList.apply(this, arguments);
        }
        function _fragmentTagsList() {
            _fragmentTagsList = // 片段标签
            _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
                var res, _tags;
                return regeneratorRuntime.wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            _ctx.next = 3;
                            return getFragmentTags();
                        case 3:
                            res = _ctx.sent;
                            if (!res.data.code) {
                                ;
                                fragmentTags.value = (_tags = res.data.data.tags) !== null && _tags !== void 0 ? _tags : [];
                            }
                            _ctx.next = 10;
                            break;
                        case 7:
                            _ctx.prev = 7;
                            _ctx.t0 = _ctx["catch"](0);
                            console.error(_ctx.t0);
                        case 10:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        7
                    ]
                ]);
            }));
            return _fragmentTagsList.apply(this, arguments);
        }
        watch(function() {
            return activeTab.value;
        }, function(val) {
            var _$ref;
            formQuery.query = _objectSpread({}, formItemQuery);
            formQuery.query.types = val === 0 ? "" : String(val);
            treeParams.asset_type = val;
            checkedRow.value = [];
            if ((_$ref = treeRef.value) === null || _$ref === void 0 ? void 0 : _$ref.treeRef) {
                var _$ref1;
                (_$ref1 = treeRef.value) === null || _$ref1 === void 0 ? void 0 : _$ref1.treeRef.setCurrentKey(null);
            }
            // 修改路由参数,去除切换tabs的带来的参数问题
            root.$router.push({
                query: _objectSpread({}, formQuery.query)
            });
            refreshAssetList();
        }, {
            deep: true
        });
        watch(function() {
            return root.$route;
        }, function() {
            refreshAssetList();
        });
        onMounted(function() {
            fragmentTagsList();
            // 初始化路由参数，去除刷新的带来的参数问题
            root.$router.push({
                query: _objectSpread({}, formItemQuery)
            });
            watch(function() {
                return resourceTable.tableList;
            }, function() {
                treeHeight.value = getTreeHeight();
            });
        });
        return _objectSpreadProps(_objectSpread({}, toRefs(formQuery)), {
            treeRef: treeRef,
            formList: formList,
            radioValue: radioValue,
            rowItem: rowItem,
            resourceTable: resourceTable,
            formItemQuery: formItemQuery,
            checkedRow: checkedRow,
            treeParams: treeParams,
            treeHeight: treeHeight,
            tableListRef: tableListRef,
            tabsLoading: tabsLoading,
            fragmentTags: fragmentTags,
            editVisible: editVisible,
            changeRadio: changeRadio,
            handleNodeId: handleNodeId,
            handleClickRow: handleClickRow,
            refreshAssetList: refreshAssetList,
            handleSortChange: handleSortChange,
            handleSelectionChange: handleSelectionChange,
            checkedTableColumns: checkedTableColumns
        });
    }
});
